import { getContainerId } from "./getContainerID";

export const getCustomerEmail = () => {
    const containerId = getContainerId();
    const container = document.getElementById(containerId!);
    if (container) {
        return container.dataset.customeremail || "";
    }
}